module.exports = __webpack_public_path__ + "img/taoyuan-6.4d037480.jpg";